<div class="bookingCardWrapper">
    <div class="date">
        Booking requested: <span>{{booking.created.toDate() | date:"MM/dd/YYYY h:mma"}}</span>
    </div>

    <div class="bookingCard">
        <div class="poster">

            <div class="posterImage">
                <img [src]="booking?.movie?.Poster" alt="">
                <!-- <div class="add">
                <mat-icon>add_2</mat-icon>
            </div> -->
            </div>
            <app-add *ngIf="booking?.movie" [movie]="booking?.movie"></app-add>
        </div>
        <div class="info">
            <div class="title">{{booking?.movie?.Title}}</div>
            <div class="booking">
                Booking request: {{ booking.startDate | dateRange : booking.endDate }}
            </div>
            <div class="format" *ngIf="!booking.enableMultipleTheaters">
                THEATER: {{booking.theater}} - {{booking.city}}, {{booking.state}}
            </div>
            <div class="format" *ngIf="booking.enableMultipleTheaters">
                THEATERS: <br>
                <div *ngFor="let theater of booking.theaterListObj">
                    {{theater.name}} - {{theater.city}}, {{theater.state}} <br>
                </div>

            </div>
            <div class="format">
                FORMAT: {{booking.format}}
            </div>
            <div class="terms">
                TERMS: {{booking.terms}}
            </div>

            <div class="split">
                <div class="item">
                    <a routerLink="/contact" class="sales">Contact Sales</a>
                </div>
                <!-- <div class="item">
                <a (click)="onCancel()" class="sales">Cancel Booking</a>
            </div> -->
                <div class="item">
                    <a [routerLink]="['/movies/', ''+booking.movie?.Dx]" routerLinkActive="router-link-active"
                        class="sales">More Info</a>
                </div>

                <!-- <div class="item" *ngIf="isCancellable">
                    <a class="cancel" (click)="onCancel()">Cancel Booking</a>
                </div> -->
            </div>
        </div>
    </div>
</div>